import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { ConfirmDialog } from "@bookips/sds";
import { getOrigin, NICE_FORM_URL } from "./CashCharge";
import useGetNiceAuthData from "./hooks/useGetNiceAuthData";
const VerificationDialog = (param)=>{
    let { open , title , description , onClose  } = param;
    const { data: niceAuthData  } = useGetNiceAuthData({
        returnUrl: "".concat(getOrigin(), "/wallet/cash/"),
        enabled: !!getOrigin()
    });
    const handleCertification = ()=>{
        mixpanelEvent("Popup Button Clicked", {
            "Popup Title": "안전한 이용을 위해 본인 인증이 필요해요.",
            "Button Name": "인증하기",
            position: "cash"
        });
        if (!niceAuthData) {
            ;
            return;
        }
        const popup = window.open("", "nicePopup", "width=430,height=700,scrollbars=yes,resizable=no");
        if (!popup) {
            ;
            return;
        }
        const form = document.createElement("form");
        form.method = "POST";
        form.action = NICE_FORM_URL;
        form.target = "nicePopup";
        const inputData = {
            m: "service",
            token_version_id: niceAuthData.tokenVersionId,
            enc_data: niceAuthData.encrypted,
            integrity_value: niceAuthData.integrityCheck
        };
        Object.entries(inputData).forEach((param)=>{
            let [name, value] = param;
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        open: open,
        title: title,
        description: description,
        onConfirm: handleCertification,
        onCancel: onClose,
        confirmText: "인증하기",
        cancelText: "취소"
    });
};
export default VerificationDialog;
